const ru = {
  searchPlaceholder: 'Поиск по вашим словам',
  allQuestionsButtonLabel: 'Все вопросы',
  showMoreText: 'Показать больше',
  showLessText: 'Показать меньше',
  noResultsText: 'Результаты не найдены',
  labelText: 'Стадия проекта',
};

export default ru;
